import { render, staticRenderFns } from "./ScheduleBeauty.vue?vue&type=template&id=1baa43de"
import script from "./ScheduleBeauty.vue?vue&type=script&lang=js"
export * from "./ScheduleBeauty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports